import { render, staticRenderFns } from "./coreButton.vue?vue&type=template&id=37508d56"
import script from "./coreButton.vue?vue&type=script&lang=js"
export * from "./coreButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports